import SignInModal from './SignInModal.jsx'

export default SignInModal;



// WEBPACK FOOTER //
// ./src/components/SignInModal/index.js